import React from "react";
import { useNavigate } from "react-router-dom";
import { useRegion } from "../../../context/RegionContext";
import "./RegionSwitcher.css";
// Importing flag images
import NZFlag from "../../../assets/png/new-zealand.png";
import USFlag from "../../../assets/png/united-states.png";

const RegionSwitcher = () => {
    const navigate = useNavigate();
    const { region } = useRegion();

    const handleRegionSwitch = () => {
        const newRegion = region === 'nz' ? 'us' : 'nz';
        navigate(`/${newRegion}`);
    };

    return (
        <div className="region-switcher-container">
            <div
                className={`region-toggle ${region === 'nz' ? 'active-nz' : 'active-us'}`}
                onClick={handleRegionSwitch}
                title="Click to switch region"
            >
                <div className="toggle-handle"></div>

                <div className="toggle-option nz-option" title="NZ">
                    <img src={NZFlag} alt="New Zealand" className="toggle-flag-img" />
                </div>
                <div className="toggle-divider"></div>
                <div className="toggle-option us-option" title="USA">
                    <img src={USFlag} alt="United States" className="toggle-flag-img" />
                </div>
            </div>
        </div>
    );
};

export default RegionSwitcher;
